import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=437dc8be&scoped=true&"
var script = {}
import style0 from "./Back.vue?vue&type=style&index=0&id=437dc8be&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437dc8be",
  null
  
)

export default component.exports